import Navigation from '../components/Navigation';

export default function Legal() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-12">Legal Information</h1>
          
          <div className="space-y-8 border rounded-lg p-8">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Terms of Service</h2>
              <p className="text-muted-foreground mb-4">
                This is a sample legal page. Add your terms of service here.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Privacy Policy</h2>
              <p className="text-muted-foreground mb-4">
                Add your privacy policy content here.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
} 